import moment from 'moment';

import { Http } from '../../../support';

const availlableTypes = ['cancelaciones'];

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  actionBusy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
    tipo: [...availlableTypes],
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.archivos = {
      ...state.modulo.cancelaciones.archivos,
      ...data,
    };
  });
};

const download = async (store, selectedRowKeys) => {
  store.setState((state) => {
    state.modulo.cancelaciones.archivos.actionBusy = true;
  });

  try {
    const response = await Http.get(`${window.BONJOUR_URL}/api/files/cancelaciones/${selectedRowKeys[0]}?as=link`);

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.cancelaciones.archivos.actionBusy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.cancelaciones.archivos.actionBusy = false;
      state.modulo.cancelaciones.archivos.error = error.data || error;
    });
  }
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.archivos.data = {
      ...state.modulo.cancelaciones.archivos.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.cancelaciones.archivos = {
      ...state.modulo.cancelaciones.archivos,
      busy: true,
      error: undefined,
      result: undefined,
      pagination: {
        ...state.modulo.cancelaciones.archivos.pagination,
        ...params,
        links: undefined,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.cancelaciones.archivos;

    const body = {
      ...pagination,
      ...params,
      tipo: availlableTypes,
    };
    const response = await Http.get(`/api/excel-files`, { params: body });

    store.setState((state) => {
      state.modulo.cancelaciones.archivos = {
        ...state.modulo.cancelaciones.archivos,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.cancelaciones.archivos.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.cancelaciones.archivos.busy = false;
      state.modulo.cancelaciones.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.cancelaciones.archivos = {
      ...initialState,
    };
  });
};

const CancelacionesListStore = {
  state: () => initialState,
  actions: {
    change,
    download,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default CancelacionesListStore;
